/**
 * Operator catalog for the global jump palette.
 * Only these drawer groups are exposed on the systems we operate (dev/hosting).
 * QC, scrums, SMS, IPSET, calendar, admin users, etc. stay out of Ctrl+K.
 */
export const PALETTE_ALLOWED_GROUPS: string[] = [
  '/server',
  '/websites',
  '/website-migrations',
  '/plans',
  '/vhost',
  '/dns',
  '/ssl',
  '/system-users',
  '/databases',
  '/mailboxes',
  '/ftp-users',
  '/backups',
  '/usage',
];

export const PALETTE_GROUP_LABELS: { [group: string]: string } = {
  '/server': 'Servers',
  '/websites': 'Websites',
  '/website-migrations': 'Website Migrations',
  '/plans': 'Plans',
  '/vhost': 'Vhost',
  '/dns': 'DNS',
  '/ssl': 'SSL',
  '/system-users': 'System Users',
  '/databases': 'Databases',
  '/mailboxes': 'Mailboxes',
  '/ftp-users': 'FTP Users',
  '/backups': 'Backups',
  '/usage': 'Usage',
};

export function isAllowedPaletteGroup(group: string): boolean {
  return PALETTE_ALLOWED_GROUPS.indexOf(group) !== -1;
}

export function isAllowedPalettePath(path: string | undefined): boolean {
  if (!path) {
    return false;
  }
  // Restore tasks live under backups IA but use /restores routes.
  if (path === '/restores' || path.indexOf('/restores/') === 0) {
    return true;
  }
  return PALETTE_ALLOWED_GROUPS.some((group) => path === group || path.indexOf(`${group}/`) === 0);
}
